define([
    "dojo/_base/declare",
    "csi",
    "csi/heading/SelectController",
    "csi/xml"
], function(declare,csi,SelectController,xml) {

    return declare(SelectController, {
        process: function() {
            // summary: cache selected node before continuing with processing if not already in view cache
            var self = this;
            this.newURL = this.newValue;

            this.m_cache.getNodeDeferred(this.newURL).then(function(node) {
                   SelectController.prototype.process.call(self);
            });
        },

        toWriter: function() {
            var value = this.getParent().CareSymbolTypes;
            var currentNodeIndex = value.indexOf(this.getNode().SymbolType);

            this.m_writer.changeNode(this.m_urlParent).changeAttributeKeys("CareIcons", "refvector", csi.objectNew(currentNodeIndex, this.newURL));
        },

        postProcessSuccess: function() {
            // summary: update store with new node and replace the current node with the selected node
            var view = this.widget;
            var row = view.getRefNode(this.m_element);
            var rowNext = view.getRefNodeNext(row);
            var node;

            if (xml.isValidURL(this.newURL)) {
                node = this.m_cache.getNode(this.newURL);
            } else {
                // create empty client node for this type
                node = xml.nodeCreateClientNode(null, "CareSymbol", "", null, 0);
                xml.nodeCreateClientAttr(node, "SymbolType", xml.ATTR_ENUM, this.getNode().SymbolType);
            }

            var rows = view.generateRow(node);
            view.deleteRow(row);
            view.insertRows(rows, null, rowNext, true);
            this.refNode = rows[0].firstChild;
        },

        getOldValue: function() {
            // summary: oldValue is Url of the current node, if it is a client node then it is "centric:"
            var oldValue = this.getNodeURL();

            if (xml.isClientUrl(oldValue))
                return csi.EMPTY_URL;

            return oldValue;
        },

        _fromHtmlDynamic: function() {
            // summary: new value is url of newly selected node
            return this.editNode.get("value");
        }

    });
});